import { createEntityAdapter } from '@reduxjs/toolkit'

import { WidgetWindow } from './models/WidgetWindow'

export const widgetWindowsAdapter = createEntityAdapter({
  selectId: (window: WidgetWindow) => window.id,
})
